const FALLBACK_ENV =
  (typeof globalThis !== 'undefined' &&
    typeof (globalThis as Record<string, any>).process !== 'undefined' &&
    (globalThis as Record<string, any>).process?.env) ||
  {}

function readEnv(key: string): string | undefined {
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    const envSource = import.meta.env as Record<string, string | undefined>
    return envSource[key]
  }

  return FALLBACK_ENV[key]
}

function requireEnv(key: string): string {
  const value = readEnv(key)
  if (!value) {
    throw new Error(
      `Missing required Auth0 environment variable ${key}. Review auth0-config.yaml and add ${key} to your build environment.`,
    )
  }
  return value
}

export const AUTH0_REQUIRED_ENV_VARS = [
  'VITE_AUTH0_DOMAIN',
  'VITE_AUTH0_CLIENT_ID',
  'VITE_AUTH0_CALLBACK_URL',
  'VITE_AUTH0_LOGOUT_URL',
] as const

const auth0Domain = requireEnv('VITE_AUTH0_DOMAIN')
const auth0ClientId = requireEnv('VITE_AUTH0_CLIENT_ID')
const auth0RedirectUri = requireEnv('VITE_AUTH0_CALLBACK_URL')
const auth0LogoutUri = requireEnv('VITE_AUTH0_LOGOUT_URL')
const auth0Audience = readEnv('VITE_AUTH0_AUDIENCE')

export const auth0Config = {
  domain: auth0Domain,
  clientId: auth0ClientId,
  redirectUri: auth0RedirectUri,
  logoutUri: auth0LogoutUri,
  audience: auth0Audience,
}
